(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
//
// ANCHOR SMOOTH SCROLLING
//

$(document).on('click', 'a[href^="#section-"]', function (e) {

  e.preventDefault()

  var target = this.hash
    , $target = $(target)
    , offset = 68

  $('html, body').stop().animate({
    'scrollTop': $target.offset().top - offset
  }, 500, 'swing', function () {
    window.location.hash = target
  })

})

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/smooth-scrolling.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkbWluL3NvdXJjZS9qcy9hcHAvbGliL3Ntb290aC1zY3JvbGxpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EiLCJmaWxlIjoiZ2VuZXJhdGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbIi8vXG4vLyBBTkNIT1IgU01PT1RIIFNDUk9MTElOR1xuLy9cblxuJChkb2N1bWVudCkub24oJ2NsaWNrJywgJ2FbaHJlZl49XCIjc2VjdGlvbi1cIl0nLCBmdW5jdGlvbiAoZSkge1xuXG4gIGUucHJldmVudERlZmF1bHQoKVxuXG4gIHZhciB0YXJnZXQgPSB0aGlzLmhhc2hcbiAgICAsICR0YXJnZXQgPSAkKHRhcmdldClcbiAgICAsIG9mZnNldCA9IDY4XG5cbiAgJCgnaHRtbCwgYm9keScpLnN0b3AoKS5hbmltYXRlKHtcbiAgICAnc2Nyb2xsVG9wJzogJHRhcmdldC5vZmZzZXQoKS50b3AgLSBvZmZzZXRcbiAgfSwgNTAwLCAnc3dpbmcnLCBmdW5jdGlvbiAoKSB7XG4gICAgd2luZG93LmxvY2F0aW9uLmhhc2ggPSB0YXJnZXRcbiAgfSlcblxufSlcbiJdfQ==